import { CheckIcon } from '@heroicons/react/24/outline'
import { NavLink } from 'react-router'

const features = [
  'Public, always-live schedule',
  'Members claim and swap roles themselves',
  'Recurring meeting scheduling',
  'Digest emails for upcoming meetings',
  'Speech and role history',
  'Guest join flow',
]

export default function LandingPricingTeaser() {
  return (
    <div className="bg-gray-50 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-600">
            Pricing
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Start free. Keep it for $19/month
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Run real meetings, invite your members, and decide after your club
            has actually used it. No credit card required.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-xl">
          <div className="rounded-3xl bg-white p-8 shadow-xl shadow-gray-900/5 ring-1 ring-gray-200">
            <h3 className="text-lg font-semibold leading-8 text-gray-900">
              Club
            </h3>
            <p className="mt-2 flex flex-wrap items-baseline gap-x-2">
              <span className="text-4xl font-bold tracking-tight text-gray-900">
                $0
              </span>
              <span className="text-sm font-semibold leading-6 text-gray-600">
                for 3 months
              </span>
            </p>
            <p className="mt-2 text-sm font-semibold leading-6 text-indigo-600">
              Then $19/month. Cancel or subscribe anytime.
            </p>
            <ul className="mt-6 space-y-2 text-sm leading-6 text-gray-600">
              {features.map((feature) => (
                <li key={feature} className="flex gap-x-3">
                  <CheckIcon
                    className="h-6 w-5 flex-none text-indigo-600"
                    aria-hidden="true"
                  />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mx-auto mt-10 max-w-2xl text-center">
          <p className="text-base leading-7 text-gray-600">
            No setup fee. Nothing to install. Start with the next meeting on
            your calendar.
          </p>
          <NavLink
            to="/pricing"
            className="mt-2 inline-block text-sm font-semibold leading-6 text-indigo-600 hover:text-indigo-500">
            See full pricing <span aria-hidden="true">→</span>
          </NavLink>
        </div>
      </div>
    </div>
  )
}
